import React from 'react';  
import { motion } from 'framer-motion';  
import { Shuffle, Pause, Play } from 'lucide-react';  
  
const BotonIniciar = ({ onControl, estadoJuego }) => {  
  const getLabel = () => {  
    if (estadoJuego === 'idle') return { icon: Shuffle, text: '¡Barajar y Empezar!' };  
    if (estadoJuego === 'playing') return { icon: Pause, text: 'Pausar' };  
    if (estadoJuego === 'paused') return { icon: Play, text: 'Reanudar' };  
  };  
  
  const { icon: Icon, text } = getLabel();  
  
  return (  
    <motion.button  
      onClick={onControl}  
      className={`px-8 py-4 rounded-2xl font-bold text-lg flex items-center gap-3 mx-auto transition-all duration-300 shadow-lg ${  
        estadoJuego === 'playing'  
          ? "bg-yellow-500 hover:bg-yellow-600 text-white"  
          : "bg-green-500 hover:bg-green-600 text-white"  
      }`}  
      whileHover={{ scale: 1.05 }}  
      whileTap={{ scale: 0.95 }}  
    >  
      <Icon className="w-6 h-6" />  
      {text}  
    </motion.button>  
  );  
};  
  
export default BotonIniciar;